export default "__VITE_ASSET__p3ihiwM8__"